import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-model-surroundings',
  templateUrl: './model-surroundings.component.html',
  styleUrls: ['./model-surroundings.component.css']
})
export class ModelSurroundingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
